export enum PropertyStateSources {
  HC = 'hc',
  MLS = 'mls',
  PR = 'pr',
}
